/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Icon/theme';

export const IconTheme = theme;
